<template>
  <div
    :class="{
      'is-disabled': disabled,
      not_editable: not_editable,
      'is-ios': isIos,
      'is-mirror': isMirror,
      'only-audio-player': !hasVideo,
      additionalClass
    }"
    class="video-source customClass"
    @contextmenu.prevent
  >
    <vue-video-player
      v-if="!is_youtube"
      ref="videoPlayer"
      class="vjs-custom-skin"
      :class="{ 'fullscreen-mode': isFullScreenMode }"
      :options="playerOptions"
      disable-picture-in-picture
      @ended="videoEndedHandler($event)"
      @play="videoPlayHandler($event)"
      @pause="videoPauseHandler($event)"
      @ready="playerReadied"
      @statechanged="player_state_changed($event)"
      @waiting="onPlayerWaiting($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @error="error($event)"
    />

    <div v-else-if="data_setup" class="vjs-custom-skin">
      <div id="youtube-player"></div>

      <!-- <video
        :id="'video_' + timestamp"
        ref="youtube_player"
        class="video-js video-js__youtube"
        disable-picture-in-picture
        controls
        :width="width"
        :height="height"
        :data-setup="data_setup"
      ></video> -->
    </div>
  </div>
</template>

<script>
// import videojs from 'video.js';
import 'videojs-youtube/dist/Youtube.js';
import { videoPlayer, videojs as videoJsPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import { load_script } from '@/_helpers/utils.js';

// onYouTubeIframeAPIReady = () => {
//   console.log("onYouTubeIframeAPIReady");
//   vueApp.initYoutube();
// };

// var tag = document.createElement('script');
// tag.src = 'https://www.youtube.com/iframe_api';
// var firstScriptTag = document.getElementsByTagName('script')[0];
// firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

export default {
  name: 'VideoPlayer',

  components: {
    VueVideoPlayer: videoPlayer
  },

  props: {
    src: String,

    additionalClass: String,

    is_playsinline: Boolean,

    is_muted: Boolean,

    isIos: Boolean,

    videoReadyHandler: {
      type: Function,
      default: () => {}
    },

    hasVideo: {
      type: Boolean,
      default: true
    },

    defaultPlaybackRate: {
      type: Number,
      default: 1
    },

    volume: {
      type: Number,
      default: 1
    },

    muted: {
      type: Boolean,
      default: false
    },

    is_recorder: {
      type: Boolean,
      default: false
    },

    isMirror: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    not_editable: {
      type: Boolean,
      default: false
    },

    height: {
      type: [Number, String, Boolean],
      default: false
    },

    has_playback_rates: {
      type: Boolean,
      default: true
    },

    is_youtube: {
      type: Boolean,
      default: false
    },

    width: {
      type: Number,
      default: 564
    }
  },

  data() {
    return {
      playerOptions: {
        sources: [{ type: 'video/mp4', src: this.src }],
        playbackRates: this.has_playback_rates ? [1.0, 1.25, 1.5, 2.0] : [],
        fluid: true,
        autoplay: false,
        timestamp: '0',
        height: this.height || 375,
        width: this.width || 564,
        controlBar: {
          remainingTimeDisplay: false,
          progressControl: this.not_editable ? false : true,
          playToggle: true
        }
      },

      controlBar: {
        remainingTimeDisplay: false,
        playToggle: {},
        progressControl: {},
        fullscreenToggle: false,
        volumeMenuButton: {
          inline: false,
          vertical: true
        }
      },

      youtube_videojs: null,
      isFullScreenMode: false,
      YTplayer: null
    };
  },

  computed: {
    player() {
      if (!this.$refs || !this.$refs.videoPlayer || !this.$refs.videoPlayer.player) {
        return null;
      }
      return this.$refs.videoPlayer.player;
    },

    data_setup() {
      if (this.isIos) {
        return `{ "techOrder": ["youtube", "html5"], "sources": [{ "type": "video/youtube", "src": "${this.src}"}], "controlBar": { "remainingTimeDisplay": false, "progressControl": false, "playToggle": false } }`;
      }
      if (!this.not_editable) {
        return `{ "techOrder": ["youtube", "html5"], "sources": [{ "type": "video/youtube", "src": "${this.src}"}] }`;
      } else {
        return `{ "techOrder": ["youtube", "html5"], "sources": [{ "type": "video/youtube", "src": "${this.src}"}], "controlBar": { "remainingTimeDisplay": false, "progressControl": false, "playToggle": false } }`;
      }
    },

    youTubeId() {
      let rx =
        /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

      return this.src.match(rx)[1] ?? null;
    }
  },

  // watch: {
  //   YTplayer(val) {
  //     console.log(val.PlayerState);
  //   }
  // },

  beforeMount() {
    const date = new Date();
    this.timestamp = date.getTime();
  },

  mounted() {
    this.videoPlayerInit();

    load_script('https://www.youtube.com/iframe_api', 'youtube-api', () => {}, 'defer');

    if (this.is_youtube && this.youTubeId) {
      const initYoutubePlayer = () => {
        const videoEl = document.getElementById('youtube-player');

        // YT instance is from youtube api js embedded file
        this.YTplayer = new YT.Player(videoEl, {
          height: 360,
          videoId: this.youTubeId || null,
          playerVars: { fs: 0, modestbranding: 1, rel: 0, showinfo: 0 },
          events: { onStateChange: this.youTubeStateChanged }
        });
      };

      window.onYouTubeIframeAPIReady = initYoutubePlayer();
    }
  },

  // updated() {
  //   this.videoPlayerInit();
  // },

  beforeDestroy() {
    if (this.myPlayer) {
      this.myPlayer.off('play');
      this.myPlayer.off('pause');
      this.myPlayer.off('ended');
      this.myPlayer.off('waiting');
      this.myPlayer.dispose();
    }
  },

  methods: {
    youTubeStateChanged(event) {
      const eventCode = event.data;

      switch (eventCode) {
        case 1: // play
          this.videoPlayHandler(event);
          this.$emit('onPlayerTimeupdate', parseInt(this.YTplayer.getCurrentTime()));
          break;

        case 2: // pause
          this.videoPauseHandler(event);
          break;

        case 0: // ended
          this.videoEndedHandler(event);
          break;

        default:
          break;
      }

      // myPlayer.on('waiting', function (e) {
      //   self.onPlayerWaiting(e);
      // });
    },

    videoPlayerInit() {
      if (this.src === undefined) {
        // this.sentry_display();
      }

      if (this.height !== false) {
        this.playerOptions.fluid = false;
      }

      this.$emit('rdy');

      // const videos = document.getElementsByClassName('vjs-tech');
      // videos.forEach(item => {
      //   item.disablePictureInPicture = true;
      // });

      // if (this.is_youtube) {
      //   const self = this;

      //   const id = `video_${this.timestamp}`;
      //   videojs(id).ready(function () {
      //     var myPlayer = this;
      //     self.youtube_videojs = myPlayer;

      //     myPlayer.on('play', function (e) {
      //       self.videoPlayHandler(e);
      //     });

      //     myPlayer.on('pause', function (e) {
      //       self.videoPauseHandler(e);
      //     });

      //     myPlayer.on('ended', function (e) {
      //       self.videoEndedHandler(e);
      //     });

      //     myPlayer.on('waiting', function (e) {
      //       self.onPlayerWaiting(e);
      //     });

      //     myPlayer.on('timeupdate', function () {
      //       self.$emit('onPlayerTimeupdate', parseInt(myPlayer.currentTime()));
      //     });
      //   });
      // }
    },

    player_state_changed(ev) {
      if (ev.error) {
        console.log(ev.error);
        // this.sentry_display();
      }
      this.$emit('player_state_changed', ev);
    },

    videoEndedHandler(ev) {
      this.$emit('videoEndedHandler', ev);
    },

    videoPlayHandler(ev) {
      this.$emit('videoPlayHandler', ev);
    },

    videoPauseHandler(ev) {
      this.$emit('videoPauseHandler', ev);
    },

    error(ev) {
      // if (this.$raven) {
      //   this.$raven.captureException(new Error('VIDEO-error'), {
      //     extra: this.src
      //   });
      // }
      this.$emit('error', ev);
    },

    onPlayerWaiting(ev) {
      this.$emit('onPlayerWaiting', ev);
    },

    onPlayerTimeupdate(ev) {
      this.$emit('onPlayerTimeupdate', parseInt(ev.currentTime()));
    },

    playerReadied(ev) {
      // Disable video in window for YaBrowser
      const video = this.$el.querySelector('video');
      video.setAttribute('pip', false);

      if (this.player) {
        this.player.playbackRate(this.defaultPlaybackRate);
        this.player.volume(this.is_recorder ? 0 : this.volume);
        this.player.muted(this.is_recorder ? true : this.muted);
        // В iOs по дефолту video.js при включении видео автоматически раскрывается на весь экран.
        // Метод player.playsinline предотвращает такое поведение
        if (this.is_playsinline || this.isIos) {
          this.player.playsinline(true);
        }

        if (this.is_muted) {
          this.player.muted(true);
        }

        this.rate_change();

        if (this.isIos) {
          var Button = videoJsPlayer.getComponent('Button');

          var FullButton = videoJsPlayer.extend(Button, {
            //constructor: function(player, options) {
            constructor: function () {
              Button.apply(this, arguments);
              //this.addClass('vjs-chapters-button');
              this.addClass('vjs-fullscreen-control');
              this.controlText('Fullscreen');
            },

            handleClick: () => {
              // alert('Fullscreen');
              this.isFullScreenMode = !this.isFullScreenMode;
            }
          });

          videoJsPlayer.registerComponent('FullButton', FullButton);

          this.player.getChild('controlBar').removeChild('fullscreenToggle');
          this.player.getChild('controlBar').addChild('FullButton', {}, 13);
        }
      }
      if (this.is_playsinline) {
        const video = document.querySelector('video');
        if (video) {
          video.controls = false;
        }
      }
      this.videoReadyHandler(ev);
    },

    rate_change() {
      this.player.on('ratechange', () => {
        const rate = this.player.playbackRate();
        this.$emit('change_playback_rate', rate);
      });

      this.player.on('volumechange', () => {
        this.$emit('change_volume', this.player.volume());
        this.$emit('change_muted', this.player.muted());
      });
    },

    // sentry_display() {
    //   if (this.$raven) {
    //     this.$raven.captureException(new Error('VIDEO-error'));
    //   }
    // }
  }
};
</script>

<style lang="scss">
.is-disabled {
  position: relative;
  height: 375px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 1024px) {
    height: auto;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 2;
    cursor: not-allowed;
  }
}

.not_editable {
  .video-js.vjs-has-started .vjs-tech {
    pointer-events: none;
  }

  .vjs-fullscreen-control {
    margin-left: auto;
  }
}

.is-ios {
  ::v-deep {
    *::--webkit-media-controls-play-button,
    *::-webkit-media-controls-panel,
    *::-webkit-media-controls-start-playback-button,
    video::-webkit-media-controls,
    video::-webkit-media-controls-enclosure {
      display: none !important;
    }
  }
}

.only-audio-player {
  .video-js {
    background-image: url('/static/images/elements/equalizer.jpg') !important;
    background-repeat: no-repeat !important;
    background-position: top center !important;
    background-size: cover !important;
  }
}
</style>

<style lang="scss" scoped>
// .is-mirror {
//   ::v-deep .vjs-tech,
//   ::v-deep .vjs-poster {
//     transform: scaleX(-1);
//   }
// }

::v-deep .vjs-custom-skin {
  iframe {
    width: 100%;
  }
}

.fullscreen-mode.vjs-custom-skin {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100%;
  transition: all linear 0.3s;
  z-index: 999999999;

  ::v-deep .video-js {
    width: 100%;
    height: 100% !important;
    padding: 0 !important;
  }

  ::v-deep .vjs-fullscreen-control .vjs-icon-placeholder:before {
    content: '\F109' !important;
    display: block;
    background: none;
    width: 100%;
    height: 100%;
    margin: 0;
  }
}
</style>
